import { render } from "./ThePriceManualFilters.vue?vue&type=template&id=2d7f57fd"
import script from "./ThePriceManualFilters.vue?vue&type=script&lang=js"
export * from "./ThePriceManualFilters.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__